jQuery(document).ready(function($) {
    function responsive() {
        $("#btn-menu").click(function(e) {
            $(".nav-menu").slideToggle(),
                e.stopPropagation(),
                e.stopImmediatePropagation()
        })

        if (window.matchMedia("(min-width: 767px)").matches) {
            jQuery('#slider-actus').bxSlider({
                auto: false,
                controls: true,
                pager: false,
                autoHover: true,
                minSlides: 1,
                maxSlides: 2,
                responsive: true,
                moveSlides: 1,
                preventDefaultSwipeX: false,
                slideWidth: 300
            });
        } else {
            jQuery('#slider-actus').bxSlider({
                auto: false,
                infiniteLoop: false,
                controls: true,
                pager: false,
                autoHover: true,
                minSlides: 0,
                maxSlides: 1,
                responsive: true,
                moveSlides: 1,
                preventDefaultSwipeX: false,
                slideWidth: 600
            });
        } 
    }
    responsive(), $(window).resize(function() {
        responsive();
    });
});